import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

const ActionButton = ({
  prefix,
  label,
  href,
  iconName,
  handleClick,
  disabled,
  customIconStyles,
  customButtonStyles,
  iconSide = 'left',
  pendoClassName,
  ...props
}) => {
  const standardButtonStyles = classNames(
    'NewButton',
    'NewButton--white',
    'undecorated',
    {
      'NewButton--disabled': disabled,
    },
  );
  const iconStyles = customIconStyles ? `${customIconStyles} mr-4` : 'mr-4';
  const buttonStyles = customButtonStyles
    ? `${customButtonStyles}`
    : standardButtonStyles;

  if (href) {
    return (
      <a
        className={classNames(buttonStyles, {
          [pendoClassName]: pendoClassName,
        })}
        href={disabled ? null : href}
        {...props}
      >
        {iconName && <Icon name={iconName} className={iconStyles} />}
        <span className="u-hideBelowSM">{prefix}</span> {label}
      </a>
    );
  }
  return (
    <span
      className={classNames(buttonStyles, {
        [pendoClassName]: pendoClassName,
      })}
      onClick={disabled ? null : handleClick}
      {...props}
      role="button"
      tabIndex="0"
      onKeyDown={e => e.key === 'Enter' && handleClick()}
    >
      {iconName && iconSide === 'left' && (
        <Icon name={iconName} className={iconStyles} />
      )}
      <span className="u-hideBelowSM">{prefix}</span> {label}
      {iconName && iconSide === 'right' && (
        <Icon name={iconName} className={iconStyles} />
      )}
    </span>
  );
};

export default ActionButton;
